import 'reflect-metadata'
import { Container } from 'inversify'
import getDecorators from 'inversify-inject-decorators'
import HttpService from 'src/core/services/http.service'
import { ConfigurationService } from "src/core/services/configuration.service"
import { PreferencesService } from "src/core/services/preferences.service"
import { MyTimesheetsStore } from './stores/my-timesheets-store'


// Initialize DI/IoC container
const container = new Container()
let { lazyInject } = getDecorators(container)

function initialize(app?: any) {
  if (!app) {
    app = {
      config: {}
    }
  }
  if (!container.isBound(HttpService)) {
    // Initialize services if container is not configured before
    container.bind(HttpService).toSelf().inSingletonScope().onActivation((context: any, instance: any) => {
      instance.setup(app.config.serviceUrl || app.config.ServiceUrl || `${window.location.protocol}//${window.location.host}`)
      return instance
    })
  }

  // Initialize services
  container.bind(ConfigurationService).toSelf().inSingletonScope().onActivation((context, instance) => {
    var config = instance.current()
    return instance
  })

  container.bind(PreferencesService).toSelf().inSingletonScope().onActivation((context, instance) => {
    var prefs = instance.current()
    return instance
  })
  container.bind(MyTimesheetsStore).toConstantValue(new MyTimesheetsStore())


}

export { lazyInject as resolve, container, initialize }